import { Card } from '../types'

const R2_BASE_URL = 'https://pub-f45ccbb772a5401ebe950820bd15eecf.r2.dev'

function transformLocalImagePath(localImage: string): string {
  let path = localImage
  
  path = path.replace(/^\/card-images\//, '')
  path = path.replace(/^card-images\//, '')
  
  return path
}

export function getCardImageUrl(card: Card): string | undefined {
  const cardAny = card as any
  
  if (card.imagePath) {
    const imagePath = transformLocalImagePath(card.imagePath)
    return R2_BASE_URL + '/' + imagePath
  }
  
  if (card.imageUrl) {
    return card.imageUrl
  }
  
  const localImage = cardAny.localImage || cardAny.local_image
  if (localImage) {
    const transformedPath = transformLocalImagePath(localImage)
    return R2_BASE_URL + '/' + transformedPath
  }
  
  return undefined
}

export function getCardImageOrFallback(card: Card, fallback?: string): string {
  return getCardImageUrl(card) || fallback || ''
}
